<template>
  <section v-on:click="sectionClicked">
    <Header ref="header" :class="{scrolled: scrolled}"/>
    <div class="loadingFull" v-if="loading"></div>
    <NotFound v-else-if="!page"></NotFound>
    <template v-else>
      <div class="cnt bcCnt">
        <div class="breadcrumb"
          :class="{bcSm: page.type === 'Content' && page.content.type !== 'profile',
          bcMedia: page.type === 'Content' && !['article', 'gallery',
          'event', 'profile'].includes(page.content.type)}">
          <div class="bcItem"><a href="/">
            <template v-if="lang === 'id'">Beranda</template>
            <template v-if="lang === 'en'">Home</template>
          </a></div>
          <div class="bcItem">
            <span>{{page.content.title[lang]}}</span>
          </div>
        </div>
      </div>
      <Content :page="page"/>
    </template>
    <Footer/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import Content from '@/components/Content.vue';
import Footer from '@/components/Footer.vue';
import NotFound from '@/components/NotFound.vue';

const nanoid = require('nanoid');

export default {
  name: 'read',
  components: {
    Header,
    Content,
    Footer,
    NotFound,
  },
  data() {
    return {
      loading: true,
      scrolled: false,
      read: null,

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  computed: {},
  methods: {
    doNothing() {},
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
    },
    docScrolled() {
      this.scrolled = (window.pageYOffset >= 30);
    },
  },
  created() { document.addEventListener('scroll', this.docScrolled); },
  destroyed() { document.removeEventListener('scroll', this.docScrolled); },
  mounted() {
    /**
     * Validate language
     *
     */
    if (!this.$route.params.lang) {
      let langCode = window.navigator.userLanguage || window.navigator.language;
      langCode = (langCode === 'id-ID') ? 'id' : 'en';
      const countryCode = (langCode === 'id') ? 'id' : 'us';
      window.location.href = `/${langCode}-${countryCode}`;
    }

    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';

    /**
     * Get article detail
     *
     */
    const { params } = this.$route;
    let session = localStorage.getItem('icel_ua_session');
    if (!session) {
      session = nanoid.nanoid(64);
      localStorage.setItem('icel_ua_session', session);
    }
    this.$http.get(this.$config.uri(`article/${params.code}?session=${session}`)).then((r) => {
      this.loading = false;
      if (r.data.status !== 200) return;
      this.page = { type: 'Content', content: r.data.data };
    });
  },
};
</script>

<style scoped lang="scss">
.bcCnt{
  padding: 40px 0 0;
  @media (max-width: 640px) {
    padding: 20px 0 0;
  }
  .breadcrumb{
    display: flex;
    padding: 0 0 10px;
    &.bcSm{
      max-width: 750px;
      margin: 0 auto;
    }
    &.bcMedia{
      max-width: 900px;
    }
    .bcItem{
      padding-right: 40px;
      position: relative;
      color: #767676;
      span{
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 200px;
      }
      a{
        transition: all .3s ease;
        font-weight: 600;
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 200px;
      }
      &:after{
        content: "";
        position: absolute;
        right: 15px; top: 0; bottom: 0;
        width: 10px;
        background-image: url(../assets/arrow-right-black.png);
        background-size: 10px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .65;
      }
      &:last-child{
        &:after{
          display: none;
        }
      }
    }
  }
  .pageTitle{
    font-size: 34px;
    margin: 0;
  }
}
</style>
